import * as React from "react";
import Header from "../Header";
import SimpleHeader from "../SimpleHeader";
import Footer from "../Footer";
import { LayoutProps } from "../interface/interface";
import "normalize.css";
import "./../../fonts/fonts.css";
import "../../styles/global.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import * as styles from "./style.module.css";

const Layout: React.FC<LayoutProps> = ({
  userLoggedIn,
  children,
  bannerText,
  home,
  trainer,
  thanks,
  form,
  className,
  xponential,
  footerFixed = true,
}) => {
  return (
    <div className={styles.wrapper}>
      {bannerText !== "" && !thanks && !trainer && !form && !xponential && (
        <div className={styles.banner}>{bannerText}</div>
      )}

      {!userLoggedIn && thanks && <SimpleHeader thanks />}

      {!userLoggedIn && form && <SimpleHeader form />}

      {!userLoggedIn && trainer && <SimpleHeader trainer />}

      {home && <Header userLoggedIn={userLoggedIn} />}

      {xponential && <Header userLoggedIn={userLoggedIn} />}

      <main className={`${styles.main} ${!!className === true && className}`}>
        {children}
      </main>
      {!form && <Footer fixed={footerFixed} />}
    </div>
  );
};

export default Layout;
